export default __webpack_public_path__ + "static/media/timeline-completa.9c347141.svg";